import './AddNewsPage.scss';
import { Button, Card, Dropdown, Icon, Input, Loader, Textarea, Typography } from '@design-system/index';
import { Formik } from 'formik';
import { NewsLine } from '@icons';
import { useAddNewsPageVM } from './useAddNewsPageVM';
import { NewsToCreate } from '@services/product/news/news.types';
import { FileUpload } from '@components/index';
import { CdnFile } from '@services/core/cdn/file/file';

export default function AddNewsPage() {
    const { submitForm, isLoading, news, isEdit, newsCategories, addDocument, deleteDocument, newsDocuments, editDocument } = useAddNewsPageVM();

    console.log("newsDocuments", newsDocuments);

    if (isLoading && isEdit) {
        return <Loader className="full-container-loader" />;
    }

    return (
        <div className="add-product-container">
            <Card
                isLoading={isLoading}
                headerType="full"
                showBack
                headerTitle={isEdit ? "Modification d'une actualité" : "Création d'une nouvelle actualité"}
                headerIcon={<Icon icon={<NewsLine />} size={20} color="primary" />}
            >
                <>
                    <Formik
                        initialValues={{
                            newsCategory: news?.newsCategory?.id ?? 0,
                            title: news?.title ?? '',
                            content: news?.content ?? '',
                            excerpt: news?.excerpt ?? '',
                            coverImage: news?.coverImage,
                          
                            images: news?.images ?? [],
                            documents: []
                        }}
                        enableReinitialize={true}
                        onSubmit={async (values: NewsToCreate) => {
                            await submitForm(values);
                        }}
                    >
                        {({ values, handleChange, handleSubmit, setFieldValue, isSubmitting }) => {
                            return (
                                <form onSubmit={handleSubmit} className="form">
                                    <div className="form-section-container">
                                        <div className="form-section">
                                            <Typography intrinsic="h3">Catégorie</Typography>
                                            <div className="form-section-fields">
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        {newsCategories.length > 0 ? (
                                                            <Dropdown
                                                                label="Catégorie"
                                                                required
                                                                options={newsCategories.map((category) => ({
                                                                    id: category.id,
                                                                    label: category.name
                                                                }))}
                                                                value={values.newsCategory}
                                                                onOptionChange={(option) => setFieldValue('newsCategory', option.id)}
                                                            />
                                                        ) : (
                                                            <div>Chargement des catégories...</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-section">
                                            <Typography intrinsic="h3">Informations</Typography>
                                            <div className="form-section-fields">
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Input
                                                            label="Titre"
                                                            required
                                                            name="title"
                                                            value={values.title}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Textarea
                                                            label="Extrait"
                                                            height={75}
                                                            name="excerpt"
                                                            value={values.excerpt ?? ''}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <Textarea
                                                            label="Contenu"
                                                            height={220}
                                                            wysiwyg
                                                            name="content"
                                                            value={values.content ?? ''}
                                                            onChange={(value) => {
                                                                setFieldValue('content', value);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-section">
                                            <Typography intrinsic="h3">Documents</Typography>
                                            <div className="form-section-fields">
                                                {values && (
                                                    <div className="form-line">
                                                        <FileUpload
                                                            width="100%"
                                                            height="214px"
                                                            isMultiple={true}
                                                            isImage={false}
                                                            table={true}
                                                            accept="application/pdf"
                                                            files={newsDocuments || []}
                                                            onOneSuccess={(file: CdnFile) => {
                                                                addDocument(file);
                                                            }}
                                                            onOneDelete={(file: CdnFile) => {
                                                                deleteDocument(file.id);
                                                            }}
                                                            onOneEdit={(file: CdnFile) => {
                                                                editDocument(file);
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-section">
                                            <Typography intrinsic="h3">Photos</Typography>
                                            <div className="form-section-fields">
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <FileUpload
                                                            width="100%"
                                                            height="248px"
                                                            caption="Photo de couverture"
                                                            subtitle={
                                                                <>
                                                                    Photo au format paysage rectangulaire.
                                                                    <br />
                                                                    Formats acceptés : PNG, JPEG. Ratio conseillé : 1920x454 pixels.
                                                                </>
                                                            }
                                                            isMultiple={false}
                                                            isImage={true}
                                                            files={values.coverImage}
                                                            onSuccess={(files: CdnFile[]) => {
                                                                setFieldValue('coverImage', files[0]);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-line">
                                                    <div className="form-group">
                                                        <div className="form-group-file-upload-grid">
                                                            <FileUpload
                                                                width="465px"
                                                                height="310px"
                                                                caption="Photo illustratives"
                                                                subtitle={
                                                                    <>
                                                                        Photo au format paysage rectangulaire.
                                                                        <br />
                                                                        Formats acceptés : PNG, JPEG. Ratio conseillé : 1280x720 pixels.
                                                                    </>
                                                                }
                                                                isMultiple={false}
                                                                isImage={true}
                                                                files={values.images?.[0]}
                                                                position={0}
                                                                onSuccess={(files: CdnFile[]) => {
                                                                    const newImages = values.images ? [...values.images] : [];
                                                                    newImages[0] = files[0];
                                                                    setFieldValue('images', newImages);
                                                                }}
                                                            />
                                                            <FileUpload
                                                                width="310px"
                                                                height="310px"
                                                                variant="light"
                                                                isMultiple={false}
                                                                isImage={true}
                                                                files={values.images?.[1]}
                                                                position={1}
                                                                onSuccess={(files: CdnFile[]) => {
                                                                    const newImages = values.images ? [...values.images] : [];
                                                                    newImages[1] = files[0];
                                                                    setFieldValue('images', newImages);
                                                                }}
                                                            />
                                                            <div className="form-group-file-upload-grid-items">
                                                                {[
                                                                    ...Array(
                                                                        Math.max(
                                                                            2,
                                                                            (values.images?.filter((img) => img?.id != null).length || 0) -
                                                                                1
                                                                        )
                                                                    )
                                                                ].map((_, index) => (
                                                                    <FileUpload
                                                                        key={index}
                                                                        width="206px"
                                                                        height="148px"
                                                                        variant="light"
                                                                        isMultiple={false}
                                                                        isImage={true}
                                                                        position={index + 2}
                                                                        files={values.images?.[index + 2]}
                                                                        onSuccess={(files: CdnFile[]) => {
                                                                            const newImages = values.images ? [...values.images] : [];
                                                                            newImages[index + 2] = files[0];
                                                                            setFieldValue('images', newImages);
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="action-buttons">
                                        <Button type="submit" disabled={isSubmitting} variant="primary">
                                            {isEdit ? 'Valider la modification' : 'Valider la création'}
                                        </Button>
                                    </div>
                                </form>
                            );
                        }}
                    </Formik>
                </>
            </Card>
        </div>
    );
}
